import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import { ApiEmployeeShort } from "@/types/employees/employee.types.ts";
import { Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface CommentsCountProps {
  totalComments: number;
  commentersPreview: ApiEmployeeShort[];
}

export const CommentsCount = ({ totalComments, commentersPreview }: CommentsCountProps) => {
  const { t } = useTranslation();
  return (
    <Stack direction={"horizontal"} gap={"sm"} items={"center"}>
      <Stack direction={"horizontal"} gap={"xs"}>
        {commentersPreview.map((author) => (
          <EmployeeAvatar employee={author} size={"sm"} key={`comment-author-${author.id}`} />
        ))}
      </Stack>

      <Text className={"text-brand-dark font-semibold text-sm"}>
        {t("plurals:comments_left", { count: totalComments })}
      </Text>
    </Stack>
  );
};
